import styled from "styled-components"

export const HeaderLabelWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 4px;
	width: fit-content;
	.containerIcon {
		display: flex;
		justify-content: center;
		align-items: center;
		color: #a5b0c0;
	}
	.containerLabel {
		display: flex;
		justify-content: center;
		align-items: center;
		color: #625783;
		font-weight: 700;
		font-size: 16px;
		padding-top: 4px;
	}

	.containerTooltip {
		display: flex;
		justify-content: center;
		align-items: center;
		> div {
			border-radius: 50px;
			width: 14px;
			height: 14px;
			background-color: #ad9fff;
			display: flex;
			justify-content: center;
			align-items: center;
			color: #5b3fff;
			font-size: 12px;
		}
	}
`
